import { render } from "./DispositionRegistration.vue?vue&type=template&id=2467a1a6&scoped=true"
import script from "./DispositionRegistration.vue?vue&type=script&lang=js"
export * from "./DispositionRegistration.vue?vue&type=script&lang=js"

import "../css/DispositionRegistration.css?vue&type=style&index=0&id=2467a1a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2467a1a6"]])

export default __exports__